import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { MotorcycleTripsView } from 'views/experience-module/MotorcycleTripsView';
import isCrawlers from 'lib/utils/isCrawlers';
import { serverFetch } from 'lib/utils/serverFetch';
import { API } from 'lib/config/axios';
import { HydrationWrapper } from 'views/common/components/HOC/HydrationWrapper';

const MotorcycleTripsPage = (props) => {
  const { serverData } = props;
  return (
    <>
      <HydrationWrapper>
        <MotorcycleTripsView serverData={serverData} />
      </HydrationWrapper>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { locale } = ctx;
  const ssrRender = isCrawlers(ctx.req.headers['user-agent']);
  let serverData = null;
  let layoutData = null;
  let serverError = null;

  const hreflangData = generateHreflang(
    PATHS.motorcycleTrips.index().url,
    locale,
  );

  if (ssrRender && ctx.pathname != '/_error') {
    const [layoutRes, motorcycleTripsData] = await Promise.all([
      serverFetch(ctx, API.layout, ctx.query),
      serverFetch(ctx, API.motorcycleTrips.index, {
        preferred_seo_identifer: new URL(hreflangData.canonical).pathname,
      }),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
    } else {
      ctx.res.statusCode = 503;
      throw new Error('Rendering halted because we failed to load layout data');
    }
    if (motorcycleTripsData.success && motorcycleTripsData.data) {
      serverData = motorcycleTripsData.data;
    } else {
      serverError = {
        statusCode: motorcycleTripsData.error.response.status,
      };
    }
  }
  if (serverError) {
    ctx.res.statusCode = serverError.statusCode;
  }

  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_motorcycle_trips_page',
        'fe_er_expandable_description_component',
      ])),
      ssrRender,
      hreflangData,
      serverData,
      layoutData,
      serverError,
      options: {
        showAiChat: true,
        skipLayoutFromGlobal: true,
      },
    },
  };
}
export default MotorcycleTripsPage;
